{
  "entry": {
    "title": "Kemasukan Pesanan",
    "subtitle": "Kemasukan Pesanan Penyedia Berkomputer (CPOE)",
    "searchSection": {
      "title": "Cari & Tambah Pesanan",
      "cosignNotice": "Pesanan anda memerlukan tandatangan bersama doktor bertugas sebelum diaktifkan."
    },
    "pending": {
      "title": "Pesanan Tertangguh",
      "clearAll": "Kosongkan Semua",
      "collapseAria": "Tutup butiran",
      "expandAria": "Kembangkan butiran",
      "removeAria": "Buang pesanan",
      "startDateTime": "Tarikh/Masa Mula",
      "ariaStartDate": "Tarikh mula pesanan",
      "ariaStartTime": "Masa mula pesanan",
      "clinicalIndication": "Indikasi Klinikal",
      "clinicalIndicationPlaceholder": "Sebab membuat pesanan…",
      "specialInstructions": "Arahan Khas",
      "specialInstructionsPlaceholder": "Arahan tambahan untuk unit pelaksana…",
      "diagnosisLabel": "Diagnosis (ICD-10)",
      "diagnosisPlaceholder": "Cari kod diagnosis ICD-10…",
      "noActiveEncounter": "Tiada lawatan aktif — pesanan tidak dapat dibuat.",
      "placing": "Menghantar…",
      "placeAll": "Hantar Semua Pesanan ({{count}})"
    },
    "active": {
      "title": "Pesanan Aktif",
      "loading": "Memuatkan pesanan…",
      "emptyAll": "Tiada pesanan untuk pesakit ini.",
      "emptyFiltered": "Tiada pesanan {{type}}.",
      "columns": {
        "orderNumber": "No. Pesanan",
        "name": "Nama",
        "type": "Jenis",
        "priority": "Keutamaan",
        "status": "Status",
        "orderedBy": "Dipesan Oleh",
        "orderedDate": "Tarikh Pesanan",
        "actions": "Tindakan"
      },
      "external": "Luaran",
      "externalTitle": "Pesanan luaran dari {{source}}",
      "externalTitleWithId": "Pesanan luaran dari {{source}} (#{{id}})",
      "providerPlaceholder": "Doktor #{{id}}",
      "actions": {
        "complete": "Selesai",
        "cancel": "Batal",
        "completeTooltip": "Selesaikan pesanan",
        "cancelTooltip": "Batalkan pesanan"
      }
    },
    "cancelDialog": {
      "title": "Batalkan Pesanan",
      "prompt": "Sila berikan sebab membatalkan {{orderName}}.",
      "placeholder": "Sebab pembatalan (wajib)…",
      "goBack": "Kembali",
      "confirm": "Sahkan Batal"
    },
    "toast": {
      "cancelSuccess": "Pesanan berjaya dibatalkan",
      "cancelError": "Gagal membatalkan pesanan",
      "completeSuccess": "Pesanan ditandakan selesai",
      "completeError": "Gagal menyelesaikan pesanan",
      "noActiveEncounter": "Tiada lawatan aktif untuk pesakit ini. Sila buat lawatan dahulu.",
      "placedSuccess_one": "{{count}} pesanan berjaya dihantar",
      "placedSuccess_other": "{{count}} pesanan berjaya dihantar",
      "medicationFieldsRequired_one": "{{names}} memerlukan dos, laluan dan kekerapan sebelum boleh dipreskripsi",
      "medicationFieldsRequired_other": "{{count}} ubat memerlukan dos, laluan dan kekerapan: {{names}}",
      "medicationNotInFormulary_one": "{{names}} tidak dipautkan ke formulari dan tidak boleh disaring untuk alahan, interaksi atau dos — preskripsikan dari halaman ubat",
      "medicationNotInFormulary_other": "{{count}} ubat tidak dipautkan ke formulari dan tidak boleh disaring: {{names}} — preskripsikan dari halaman ubat",
      "placedError_one": "{{count}} pesanan gagal dihantar",
      "placedError_other": "{{count}} pesanan gagal dihantar",
      "orderSetApplied": "Menambah {{count}} pesanan daripada {{name}} — semak sebelum menandatangani"
    }
  },
  "catalog": "Katalog Pesanan",
  "orderedBy": "Dipesan Oleh",
  "orderedDate": "Tarikh Pesanan",
  "scheduledDate": "Tarikh Dijadualkan",
  "completedDate": "Tarikh Siap",
  "lab": "Makmal",
  "imaging": "Pengimejan",
  "medication": "Ubat",
  "procedure": "Prosedur",
  "consultation": "Konsultasi",
  "priority": {
    "label": "Keutamaan",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "Mendesak",
      "routine": "Rutin",
      "scheduled": "Dijadualkan",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "Status Pesanan",
    "values": {
      "draft": "Draf",
      "pending": "Menunggu",
      "pendingCosign": "Menunggu Tandatangan Bersama",
      "signed": "Ditandatangani",
      "sent": "Dihantar",
      "active": "Aktif",
      "ordered": "Dipesan",
      "inProgress": "Dalam Proses",
      "holdForVerify": "Tunggu Pengesahan",
      "completed": "Selesai",
      "cancelled": "Dibatalkan",
      "discontinued": "Diberhentikan",
      "archived": "Diarkibkan",
      "pendingClarification": "Menunggu Penjelasan",
      "suspended": "Digantung",
      "unknown": "Tidak Diketahui"
    }
  },
  "entryFields": {
    "searchPlaceholder": "Cari pesanan (makmal, pengimejan, ubat, prosedur)…",
    "frequency": "Kekerapan",
    "dose": "Dos",
    "route": "Laluan Pemberian",
    "indication": "Indikasi",
    "duration": "Tempoh",
    "comments": "Catatan",
    "signOrder": "Tandatangan Pesanan",
    "holdOrder": "Tangguh Pesanan",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "Katalog Pesanan",
    "searchPlaceholder": "Cari mengikut nama, kod atau sinonim…",
    "categories": "Kategori",
    "favorites": "Kegemaran",
    "recentlyUsed": "Digunakan Terkini",
    "restricted": "Terhad",
    "searchCatalog": "Cari Katalog",
    "tabs": {
      "all": "Semua",
      "lab": "Makmal",
      "imaging": "Pengimejan",
      "medication": "Ubat",
      "procedure": "Prosedur",
      "consultation": "Konsultasi"
    },
    "columns": {
      "orderName": "Nama Pesanan",
      "code": "Kod",
      "category": "Kategori",
      "description": "Penerangan",
      "defaultPriority": "Keutamaan Lalai"
    },
    "details": {
      "orderCode": "Kod Pesanan",
      "category": "Kategori",
      "defaultPriority": "Keutamaan Lalai",
      "status": "Status",
      "cptCode": "Kod CPT",
      "loincCode": "Kod LOINC",
      "synonyms": "Sinonim",
      "description": "Penerangan",
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    },
    "loading": "Memuatkan katalog…",
    "loadError": "Gagal memuatkan katalog pesanan",
    "emptyResults": "Tiada pesanan yang sepadan.",
    "pagination": "Memaparkan {{from}}-{{to}} daripada {{total}}",
    "pageIndicator": "Halaman {{page}} daripada {{totalPages}}",
    "favoriteAdd": "Tambah ke kegemaran",
    "favoriteRemove": "Buang daripada kegemaran",
    "favoriteAdded": "Ditambah ke kegemaran",
    "favoriteRemoved": "Dibuang daripada kegemaran"
  },
  "cosign": {
    "title": "Baris Gilir Tandatangan Bersama",
    "requiresCosign": "Memerlukan Tandatangan Bersama",
    "cosignedBy": "Ditandatangani Bersama oleh",
    "cosignDeadline": "Tarikh Tutup Tandatangan Bersama",
    "queueEmpty": "Tiada pesanan memerlukan tandatangan bersama.",
    "pendingCount": "{{count}} menunggu",
    "loading": "Memuatkan baris gilir tandatangan bersama…",
    "loadError": "Gagal memuatkan baris gilir tandatangan bersama.",
    "columns": {
      "patient": "Pesakit",
      "order": "Pesanan",
      "type": "Jenis",
      "orderingProvider": "Doktor Pemesan",
      "priority": "Keutamaan",
      "orderedDate": "Tarikh Pesanan",
      "action": "Tindakan"
    },
    "actions": {
      "cosign": "Tandatangan Bersama"
    },
    "toast": {
      "success": "Pesanan berjaya ditandatangani bersama",
      "error": "Gagal menandatangani pesanan bersama"
    },
    "cosigningAs": "Menandatangani bersama sebagai: {{name}}"
  },
  "sets": {
    "title": "Set Pesanan",
    "newOrderSet": "Set Pesanan Baharu",
    "addItem": "Tambah Item",
    "requiredItem": "Wajib",
    "optionalItem": "Pilihan",
    "editMode": "Mod Edit",
    "published": "Diterbitkan",
    "draft": "Draf",
    "archived": "Diarkibkan",
    "versionNotes": "Nota Versi",
    "createTitle": "Cipta Set Pesanan Baharu",
    "fields": {
      "name": "Nama",
      "category": "Kategori",
      "specialty": "Pengkhususan",
      "description": "Penerangan"
    },
    "placeholders": {
      "name": "Cth. Pemeriksaan Sakit Dada",
      "categorySelect": "Pilih kategori…",
      "specialty": "Cth. Perubatan Kecemasan",
      "description": "Penerangan ringkas…",
      "search": "Cari set pesanan…"
    },
    "categories": {
      "chestPain": "Sakit Dada",
      "sepsis": "Sepsis",
      "postOp": "Selepas Pembedahan",
      "admission": "Kemasukan",
      "discharge": "Discaj",
      "other": "Lain-lain"
    },
    "statusFilter": {
      "all": "Semua Status",
      "active": "Aktif",
      "draft": "Draf",
      "archived": "Diarkibkan"
    },
    "columns": {
      "name": "Nama",
      "category": "Kategori",
      "specialty": "Pengkhususan",
      "items": "Item",
      "status": "Status",
      "version": "Versi",
      "actions": "Tindakan"
    },
    "itemColumns": {
      "seq": "Urut",
      "type": "Jenis",
      "item": "Item",
      "priority": "Keutamaan",
      "required": "Wajib"
    },
    "itemTypes": {
      "order": "Pesanan",
      "sectionHeader": "Tajuk Bahagian",
      "instruction": "Arahan"
    },
    "actions": {
      "publish": "Terbitkan",
      "archive": "Arkibkan",
      "cancel": "Batal",
      "create": "Cipta",
      "removeItem": "Buang item"
    },
    "loading": "Memuatkan set pesanan…",
    "loadError": "Gagal memuatkan set pesanan",
    "emptyResults": "Tiada set pesanan dijumpai.",
    "expandLoading": "Memuatkan item…",
    "expandEmpty": "Set pesanan ini tiada item.",
    "validationRequired": "Nama, kategori dan pengkhususan diperlukan",
    "toast": {
      "created": "Set pesanan dicipta",
      "createError": "Gagal mencipta set pesanan",
      "published": "Set pesanan diterbitkan",
      "publishError": "Gagal menerbitkan set pesanan",
      "archived": "Set pesanan diarkibkan",
      "archiveError": "Gagal mengarkibkan set pesanan",
      "itemRemoved": "Item dibuang",
      "itemRemoveError": "Gagal membuang item"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "Cari pesanan (makmal, pengimejan, ubat, prosedur)…",
    "noResults": "Tiada pesanan dijumpai untuk \"{{query}}\"",
    "categories": {
      "all": "Semua",
      "lab": "Makmal",
      "imaging": "Pengimejan",
      "med": "Ubat",
      "procedure": "Prosedur",
      "consultation": "Konsultasi"
    },
    "addAll": "Tambah semua {{count}}"
  },
  "worklist": {
    "title": "Senarai Kerja Pesanan",
    "countBadge": "{{count}} pesanan",
    "loading": "Memuatkan pesanan…",
    "loadError": "Tidak dapat memuatkan pesanan. Sila cuba lagi.",
    "empty": "Tiada pesanan sepadan dengan penapis semasa.",
    "typeLabel": "Jenis Pesanan",
    "allOption": "Semua",
    "columns": {
      "patient": "Pesakit",
      "order": "Pesanan",
      "type": "Jenis",
      "priority": "Keutamaan",
      "status": "Status",
      "ordered": "Dipesan"
    }
  }
}
